function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M27 0H3a3 3 0 00-3 3v24a3 3 0 003 3h24a3 3 0 003-3V3a3 3 0 00-3-3zM9 25.5H4.5V12H9zm-2.25-16a2.7 2.7 0 112.7-2.7 2.69 2.69 0 01-2.7 2.65zm18.75 16H21v-7.95a2.25 2.25 0 10-4.5 0v8H12V12h4.5v1.8a4.85 4.85 0 013.75-2.1A5.31 5.31 0 0125.5 17z",
  fill: "#0077b5"
});

function SvgLinkedin(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 30 30"
  }, props), _ref);
}

export default __webpack_public_path__ + "assets/images/linkedin.693ea125.svg";
export { SvgLinkedin as ReactComponent };